<template>
  <div>

    <div>
        <label v-if="hasAnythinOnTop" class="flex mb-1 text-base font-medium leading-[20px] justify-between text-left text-white">
            {{ label }}

            <span class="text-brand-gray-500 text-[14px] font-medium" :class="{'text-red-500': (hasError)}" v-if="requiredButHidden">
                Povinné, ale nezobrazí se
            </span>

            <span class="text-brand-gray-500 text-[14px] font-medium" v-if="!requiredButHidden && !required">
                Nepovinné
            </span>

            <span class="text-brand-gray-500 text-[14px] font-medium" v-if="secondaryLabel">
                {{ secondaryLabel }}
            </span>
        </label>
        <div class="relative flex items-center rounded-md shadow-sm">
            <input
            :value="modelValue"
            @input="onChange"
            :type="type"
            :required="required || requiredButHidden"
            :name="name"
            :placeholder="placeholder"
            class="block w-full pl-3 transition duration-150 ease-in-out border rounded-md focus:outline-none focus:ring-4 ring-brand-green ring-opacity-20 placeholder-brand-gray-500 form-input bg-brand-gray-900 border-brand-green sm:text-sm sm:leading-5"
            :class="{
              'text-red-800 bg-red-50 hover:bg-form-white focus:bg-form-white border-red-300 placeholder-red-800 ring-brand-red focus:border-red-300 focus:shadow-outline-red': hasError,
              'rounded-r-none z-10': appendEnd !== '',
              'h-[44px]': compact,
              'h-12': !compact,
            }"
            />
            <span v-if="appendEnd !== ''" :class="{'pr-8': hasIcon,
              'border-red-300 focus:border-red-300 focus:shadow-outline-red': (hasError),
              'focus:border-green-600': (!hasError)}" class="inline-flex items-center h-12 px-3 mt-1 text-gray-500 bg-[#f3f3f3] border border-l-0 border-form-gray rounded-r-md sm:text-sm">
              {{ appendEnd }}
            </span>
            <div v-if="hasError" class="absolute inset-y-0 right-0 flex items-center pr-3 mt-1 pointer-events-none">
                <svg class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>
    </div>

     <div v-if="hasError">
        <p v-for="(error, i) in errors" :key="i" class="text-sm text-left text-red-600">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {

  emits: ['update:modelValue'],

  props: {
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    compact: {
      type: Boolean,
      default: false
    },
    placeholder: {
        type: String,
        default: ''
    },
    showRequireIndicatior: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ''
    },
    appendEnd: {
      type: String,
      default: ''
    },
    requiredButHidden: {
        type: Boolean,
        default: false
    },
    secondaryLabel: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => [],
    }
  },

  computed: {
      hasError() {
          return this.errors.length > 0;
      },

      hasIcon() {
        return this.hasError;
      },

      hasAnythinOnTop() {
        return this.label || this.requiredButHidden || this.secondaryLabel;
      }
  },

  methods: {
    onChange(evt) {
      this.$emit("update:modelValue", evt.target.value);
    },
  },
};
</script>

<style>
</style>
